import { DEFAULT_CUSTOMER_USERS_LIST_FILTERS } from "./Users.constants";

export const initialState = {
  loading: true,
  error: null,
  usersList: [],
  pagination: {
    page: 0,
    size: 20,
    totalCount: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
  },
  listFilters: { ...DEFAULT_CUSTOMER_USERS_LIST_FILTERS },
};
